<template>
<div id="modalRefundRemark" class="modal fade">
    <div class="modal-dialog modal-dialog-vertical-center modal-md" role="document">
      <div class="modal-content bd-0 tx-14">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">{{$t("mall.查看备注信息")}}</h6>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25 model-auto-h">
          <div class="row bg-gray-100 pd-y-10 mg-b-15 follow-list" v-if="taskInfo.distributorRemark">
            <h4 class="col-12 tx-14 tx-gray-900 mg-b-10">{{$t("mall.经销商备注")}}</h4>
            <div>
            	<p class="mg-b-10 pd-l-15">
            		<span class="">{{taskInfo.distributorRemark}}</span>
            	</p>
            </div>
          </div>
          <div class="row bg-gray-100 pd-y-10 mg-b-15 follow-list" v-if="taskInfo.remark">
            <h4 class="col-12 tx-14 tx-gray-900 mg-b-10">{{$t("mall.退款备注")}}</h4>
            <div>
            	<p class="mg-b-10 pd-l-15">
            		<span class="">{{taskInfo.remark}}</span>
            	</p>
            </div>
          </div>
          <div class="row bg-gray-100 pd-y-10 mg-b-15 follow-list" v-if="taskInfo.skuRemark && taskInfo.skuRemark.length>0">
            <h4 class="col-12 tx-14 tx-gray-900 mg-b-10">{{$t("mall.申请售后备注")}}</h4>
            <div>
            	<p class="mg-b-10 pd-l-15" v-for="(remark,index) in taskInfo.skuRemark" :key="index">
            		<span class="">{{remark}}</span>
            	</p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary tx-11 tx-uppercase pd-y-12 pd-x-25 tx-mont tx-semibold" data-dismiss="modal">{{$t("mall.关闭")}}</button>
        </div>
      </div>
    </div>
</div>
</template>

<script>
export default {
  props: ["open", "task_info"],
  data() {
    return {
    	taskInfo:""
    };
  },
  watch: {
  	"task_info":function(){
  		this.taskInfo = this.task_info;
  	}
  },
  filters: {
  },
  methods: {
  }
};	
</script>

<style>
</style>